import { useEventStore } from "@/event";
import { EventUpgradeIds } from "@/game/entities/config/upgrades/";
import useUpgradesStore from "@/store/useUpgradesStore";
import { EventCategory } from "@/types/ui";

/** Hunting mountaineering upgrade gates HILLS-style eventium on mountains. */
export function isHuntingMountaineeringActive(): boolean {
	const { isActive, attributes } = useEventStore();
	return (
		!!(isActive && attributes.type === EventCategory.HUNTING) &&
		useUpgradesStore().getCurrentLevelById(
			EventUpgradeIds.hu_mountaineering,
		) > 0
	);
}
